export default {
  // 初始化St
  SET_REVIEWDETAIL: (state, sessionId, flag) => {
    let reviewFlag = false
    for (let i = 0; i < state.reviewList.length; i++) {
      if (state.reviewList[i] && sessionId === state.reviewList[i].sessionId) {
        reviewFlag = !reviewFlag
        return
      }
    }
    if (reviewFlag) { // 判断列表中有没有当前sessionId的信息，如果有则更改状态，没有则添加
      for (let i = 0; i < state.reviewList.length; i++) {
        if (state.reviewList[i] && sessionId === state.reviewList[i].sessionId) {
          state.reviewList[i].isSubmitted = true
          return
        }
      }
    } else {
      const item = {
        sessionId: sessionId,
        isSubmitted: flag
      }
      state.reviewList.push(item)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/review/mutation.js